import PropTypes from 'prop-types';
import React from 'react';
import { Appointment, AppointmentCellWrapper, DateWrapper } from './styles';

function AppointmentCell(props) {
  const { data: { appointmentData: { Color, Description, Duration } } } = props;
  if (!Description) {
    return (<AppointmentCellWrapper>
      <Appointment backgroundColor={Color}>
        "No appointment"
      </Appointment>
    </AppointmentCellWrapper>)
  }

  return (
    <AppointmentCellWrapper backgroundColor={Color}>
      <Appointment backgroundColor={Color}>
        {Description}
      </Appointment>
      <DateWrapper backgroundColor={Color}>
        {Duration}
      </DateWrapper>
    </AppointmentCellWrapper>
  );
}

export default AppointmentCell;

AppointmentCell.propTypes = {
  data: PropTypes.shape({
    appointmentData: PropTypes.shape({
      Color: PropTypes.string.isRequired,
      Description: PropTypes.string.isRequired,
      Duration: PropTypes.string.isRequired
    })
  }).isRequired
};